import { mainReducers, mainInitState } from "./reducer";
import { createSlice } from "@reduxjs/toolkit";

export const SLICE_NAME = "main";

export const mainState = createSlice({
  name: SLICE_NAME,
  initialState: mainInitState,
  reducers: mainReducers,
});

export const ACTIONS = mainState.actions;
export default mainState.reducer;
